import React, { useEffect, useState } from 'react'
import { useEvents } from '@smuchile/pkg-unimarc-hooks'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'
import {
  Button,
  ButtonStatus,
  Container,
  Row
} from '@smuchile/pkg-unimarc-components'
import { ICart } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/INewCartUnimarc'
import styles from './ButtonMakeOrder.module.css'

interface ButtonMakeOrderProps {
  cartData?: ICart
  isLoading?: boolean
  isLoadingByEvent?: boolean
  isLoadingMyUsualsAndFavorites?: boolean
  handleOpenMyUsualsAndFavorites?: () => void
}

const ButtonMakeOrder = ({
  cartData,
  isLoading = false,
  isLoadingByEvent = false,
  isLoadingMyUsualsAndFavorites = false,
  handleOpenMyUsualsAndFavorites
}: ButtonMakeOrderProps): React.ReactElement => {
  const [buttonStatus, setButtonStatus] = useState<ButtonStatus>('initial')
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)

  const showLoading = isLoading || isLoadingBtn

  const addressValidator =
    !cartData?.address || cartData?.address?.country !== 'CHL'
  const minValue =
    Number(
      typeof cartData?.minimumPurchase === 'string'
        ? parseFloat(cartData?.minimumPurchase.replace(/[$.]/g, ''))
        : cartData?.minimumPurchase
    ) ?? 0

  const subtotal =
    Number(
      typeof cartData?.minimumPurchase === 'string'
        ? parseFloat(cartData?.subtotal.replace(/[$.]/g, ''))
        : cartData?.subtotal
    ) ?? 0
  const hasNotMinValue = minValue !== 0 && Number(minValue) > Number(subtotal)

  const handleOnClick = async () => {
    if (hasNotMinValue) {
      return
    }

    // open my usuals and favorites modal
    handleOpenMyUsualsAndFavorites()
    setIsLoadingBtn(isLoadingMyUsualsAndFavorites)
  }

  useEvents({
    eventType: 'addressChanged',
    callBack: ({ detail: { addressChanged } }) => {
      if (addressChanged) setButtonStatus('disabled')
    }
  })

  useEffect(() => {
    if (isLoadingByEvent) {
      setButtonStatus('loading')
    } else {
      if (hasNotMinValue || addressValidator) {
        setButtonStatus('disabled')
      } else {
        setButtonStatus('initial')
      }
    }
  }, [isLoadingByEvent, cartData])

  useEffect(() => {
    if (!isLoadingMyUsualsAndFavorites) {
      setIsLoadingBtn(false)
    }
  }, [isLoadingMyUsualsAndFavorites])

  return (
    <Container isWrap>
      <Row justifyContent='center'>
        <Button
          actionType='button'
          borderRadius={getGlobalStyle('--border-radius-xl')}
          customClassName={showLoading && styles.button__loading}
          fontWeight={getGlobalStyle('--font-weight-medium')}
          height='40px'
          id='GA__button--goMyShipments'
          isLoading={showLoading}
          label='Continuar con el envío'
          onClick={handleOnClick}
          pointLoaderBigger={true}
          size='lg'
          status={buttonStatus}
          type='primary-gray'
          width='100%'
        />
      </Row>
    </Container>
  )
}

export default ButtonMakeOrder
